import React from 'react'
import { lu } from '../../data/reportData';
import { TAB, H1, H2, TXR_B, TXC_B, TXC_I, CK1 } from "../../styles/urar-styles";
import { IMAGE_1, COMMENTARY, EXHIBITS, TABLE } from "../../styles/urar-styles";
import { ADDD } from './ADDD';
import { MANUFACTURED_HOME } from './ManufacturedHome';
import { UNIT_INTERIORS } from './UnitInterior';



export function DWELLINGS() {

	global.ptr.dwelling = global.ptr.subDwelling;
	global.ptr.structure = global.ptr.subDwelling.structure;
	global.ptr.stDetail = global.ptr.subDwelling.structure.structureDetail;
	//console.log(global.ptr.dwelling,global.ptr.structure,global.ptr.stDetail );
	
	var dList = global.ptr.subDwellingList;
	//console.log("des: ", dList);

	return (
		<>
		{
			dList.map((dw, di) => {

				return (
					<React.Fragment key={di}>
						<DWELLING_EXTERIOR dwelling={dw} bldg={di+1} />
						<MANUFACTURED_HOME dwelling={dw} />
						<UNIT_INTERIORS dwelling={dw} />
					</React.Fragment>
				)
			})
		}
		</>
	)
}


export function DWELLING_EXTERIOR({dwelling, bldg}) {

	//console.log("de: ", dwelling);
	global.ptr.dwelling = dwelling;
	global.ptr.structure = dwelling.structure;
	global.ptr.stDetail = dwelling.structure.structureDetail;
	//console.log(global.ptr.dwelling,global.ptr.structure,global.ptr.stDetail );

	var heading = "Dwelling Exterior";
	if (global.ptr.subDetail.livingUnitExcludingADUCount > 1)
		heading += " - " + dwelling.structure.structureDetail.structureIdentifier;

	return (
		<>
			<TAB title={heading} />
			<div className='col2 mt-3'>
				<div>
					<TXR_B title={"Subject Property Units in\nStructure"} value={lu("8.001")} />
					<TXR_B title="Structure Design" value={lu("8.002")} />
					<TXR_B title="Floors in Building" value={lu("8.003")} />
					<TXR_B title="Dwelling Style" value={lu("8.004")} />
					<TXR_B title="Front Door Elevation" value={lu("8.005")} />
					<TXR_B title="Townhouse End Unit" value={lu("8.006")} />
					<TXR_B title="Townhouse Back to Back" value={lu("8.007")} />
					<TXR_B title="Units Above or Below" value={lu("8.008")} />
					<TXR_B title="Townhouse Location" value={lu("8.009")} />
					<TXR_B title="Year Built" value={lu("8.010")} />
					<TXR_B title="Construction Method" value={lu("8.011")} />
					<TXR_B title="Converted Area" value={lu("8.012")} />
					<TXR_B title={"Converted Area and Similarity\nto Rest of Living Area"} value={lu("8.013")} />
					<TXR_B title="Factory Built Certification" value={lu("8.014")} />
					<TXR_B title="Structure Volume" value={lu("8.015")} />
					<TXR_B title="Window Surface Area" value={lu("8.016")} />
					<TXR_B title="Attic" value={lu("8.017")} />
					<TXR_B title="Remaining Economic Life" value={lu("8.018")} />
					<TXR_B title="Effective Age" value={lu("8.019")} />
				</div>
				<div>
					<IMAGE_1 category="PropertyPhoto" />
				</div>
			</div>

			<TXC_B title="Commentary on Remaining Economic Life" value={lu("8.020")} />
			<TXC_B title="Commentary on Effective Age" value={lu("8.021")} />

			{ global.ptr.subDetail.homeownerResponsibleForExteriorMaintenanceIndicator &&
				<>
				<H1 title="Quality and Condition" />
				<div className='col2 mt-3'>
					<div>
						<TXR_B title="Exterior Quality Rating" value={lu("8.022")} />
					</div>
					<div>
						<TXR_B title="Exterior Condition Rating" value={lu("8.023")} />
					</div>
				</div>

				<TXC_I comment="The table below supports the Exterior Quality and Condition ratings and reflects the market value condition of this report" />
				<H2 title="Exterior Features" />
				<TABLE titles={["Feature","Detail","Quality Comment","Condition Status","Condition Comment"]} widths={[208,208,208,190,266]} values={lu("8.025-45")} />
				</>
			}

			{ lu("8.046") &&
			<>
				<H1 title="Noncontinuous Finished Area" />
				<TXC_I comment="The table below depicts any finished area that is attached to the dwelling but separate and not directly accessible from any unit" />
				<TABLE titles={["Finish","Total Area","Room Summary"]} widths={[180,180,180]} values={lu("8.047-48")} />
			</>
			}

			<H1 title="Mechanical System Details" />
			<div className='col2 mt-3'>
				<div>
					<TABLE titles={["","System","Detail"]} widths={[180,180,180]} values={lu("8.049-51")} />
				</div>
				<div>
					<CK1 title="Core Heating System Below Grade" value={lu("8.052")} yn />
					<TXR_B title="Other Mechanical Systems" value={lu("8.053")} />
				</div>
			</div>

			<ADDD values={lu("8.056-60")} subtitle="(Dwelling Exterior)" /> 

			<COMMENTARY title="Dwelling Exterior Commentary" value={lu("8.061")} />
			<EXHIBITS title="Dwelling Exterior Exhibits" values={lu("8.099")} />
		</>
	)
}